const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

// Generic component for triggering things via hover while handling touch
// devices. Often used in conjunction with DropdownContainer.jsx.

module.exports = createReactClass({
	displayName: "HoverRegion",

	propTypes: {
		children: PT.node.isRequired,
		className: PT.string,
		style: PT.object,
		onEnter: PT.func,
		onLeave: PT.func,
		// If true, touch events do nothing to this region.
		noSpecialTouch: PT.bool,
	},

	mouseEnter: function(evt) {
		// mouseEnter will be triggered after touchStart,
		// so this check is necessary to make sure we don't
		// double-call onEnter when touching.
		if (this.isTouching) {
			this.isTouching = false;
		} else {
			this.props.onEnter(evt);
			this.isHovered = true;
		}
	},

	mouseLeave: function(evt) {
		this.props.onLeave(evt);
		this.isHovered = false;
	},

	touchStart: function(evt) {
		if (this.props.noSpecialTouch) {
			return;
		}
		this.isTouching = true;
		// Touching toggles whether we trigger the
		// enter or leave behavior.
		if (this.isHovered) {
			this.props.onLeave(evt);
		} else {
			this.props.onEnter(evt);
		}
		this.isHovered = !this.isHovered;
	},

	render: function() {
		const {children, className, style} = this.props;
		return (
			<div
				className={className}
				style={style}
				onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}
				onTouchStart={this.touchStart}
			>
				{children}
			</div>
		);
	},
});
